module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-id-ID.d3ab8274.jpg";